import React from "react";
import Customers from "../modules/Customers/Customers";

export default function CustomersPage() {
  return <Customers />;
}
